module.exports = "/_next/static/images/b29873a304ba64e05da9f3e60643f23f-man-looking-up-smiling-md@3x.jpg";